import { useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

// Timeout durations — driven by environment variables with hardcoded fallbacks.
// To override without a code change, set these in your .env file and rebuild:
//   REACT_APP_INACTIVITY_TIMEOUT_DESKTOP_MINUTES=20
//   REACT_APP_INACTIVITY_TIMEOUT_MOBILE_MINUTES=10
const DESKTOP_MINUTES = parseInt(
  process.env.REACT_APP_INACTIVITY_TIMEOUT_DESKTOP_MINUTES || '20',
  10
);
const MOBILE_MINUTES = parseInt(
  process.env.REACT_APP_INACTIVITY_TIMEOUT_MOBILE_MINUTES || '10',
  10
);

// Detect mobile once at module load — user agent doesn't change during a session.
const IS_MOBILE = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const INACTIVITY_TIMEOUT_MS = (IS_MOBILE ? MOBILE_MINUTES : DESKTOP_MINUTES) * 60 * 1000;

export function useInactivityTimer() {
  const { logout } = useAuth();

  const resetTimer = useCallback(() => {
    clearTimeout(window._inactivityTimer);
    window._inactivityTimer = setTimeout(() => {
      logout();
      window.location.href = '/login?reason=inactivity';
    }, INACTIVITY_TIMEOUT_MS);
  }, [logout]);

  useEffect(() => {
    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer(); // Start the timer on mount

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearTimeout(window._inactivityTimer);
    };
  }, [resetTimer]);
}